import axiosConfig from './axiosConfig';
import { useMutation, useQuery } from '@tanstack/react-query';
import { createListFetcher } from './listFetchers';
import { queryClient } from './queryClient';

// List checklist items
export const getChecklistItemList = createListFetcher('checklistitem');

export const useChecklistItem = (id, options = {}) => useQuery({
    queryKey: ['checklistItem', id],
    queryFn: async () => {
        const response = await getChecklistItem(id);
        return response.data;
    },
    enabled: !!id,
    keepPreviousData: true,
    retry: 1,
    ...options,
});

// Create checklist item
export const createChecklistItem = async (itemData) => {
    try {
        const response = await axiosConfig.post('checklistitem', itemData, { headers: { 'Content-Type': 'multipart/form-data' } });
        return response;
    } catch (error) {
        throw error || 'Failed to create checklist item';
    }
};

// Show checklist item details
export const getChecklistItem = async (id) => {
    try {
        const response = await axiosConfig.get(`checklistitem/${id}`);
        return response;
    } catch (error) {
        throw error;
    }
};

// Update checklist item
export const updateChecklistItem = async (id, itemData) => {
    try {
        const response = await axiosConfig.put(`checklistitem/${id}`, itemData, { headers: { 'Content-Type': 'multipart/form-data' } });
        return response;
    } catch (error) {
        throw error || 'Failed to update checklist item';
    }
};

// Delete checklist item
export const deleteChecklistItem = async (id) => {
    try {
        const response = await axiosConfig.delete(`checklistitem/${id}`);
        return response;
    } catch (error) {
        throw error || 'Failed to delete checklist item';
    }
};

export const fetchChecklistItems = createListFetcher('checklistitem');

export const useCreateChecklistItem = (options = {}) => {
    return useMutation({
        mutationFn: createChecklistItem,
        onSuccess: () => queryClient.invalidateQueries({ queryKey: ['checklistItems'] }),
        ...options,
    });
};

export const useUpdateChecklistItem = (options = {}) => {
    return useMutation({
        mutationFn: ({ id, itemData }) => updateChecklistItem(id, itemData),
        onSuccess: () => queryClient.invalidateQueries({ queryKey: ['checklistItems'] }),
        ...options,
    });
};

export const useDeleteChecklistItem = (options = {}) => {
    return useMutation({
        mutationFn: deleteChecklistItem,
        onSuccess: () => queryClient.invalidateQueries({ queryKey: ['checklistItems'] }),
        ...options,
    });
};